import styled from 'styled-components';
import { ImageComponent } from '@/components/Image';
import { fpx } from '../../../../styles/fluid';
import type { IPaymentLogo } from '../../helpers';

export const ScPaymentLogos = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${fpx(1184)};
  height: ${fpx(74)};
  margin-top: ${fpx(18)};
  padding: ${fpx(18)};
  border-radius: ${fpx(16)};

  @media (orientation: portrait) {
    flex-direction: column;
    gap: ${fpx(16)};
    width: ${fpx(342)};
    height: auto;
    margin-top: ${fpx(32)};
    padding: 0;
    border-radius: 0;
  }
`;

export const ScPaymentRow = styled.div`
  display: contents;

  @media (orientation: portrait) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;

export const ScPaymentLogo = styled(ImageComponent)<{
  $desktop: IPaymentLogo['desktop'];
  $mobile: IPaymentLogo['mobile'];
}>`
  display: block;
  flex-shrink: 0;
  width: ${({ $desktop }) => fpx($desktop.width)};
  height: ${({ $desktop }) => fpx($desktop.height)};
  object-fit: contain;

  @media (orientation: portrait) {
    width: ${({ $mobile }) => fpx($mobile.width)};
    height: ${({ $mobile }) => fpx($mobile.height)};
  }
`;
